import styles from './waveform.module.scss';

/**
 * This component will render a little waveform animation,
 * to indicate some audio is playing.
 */
export const Waveform = () => (
  <div className={styles['waveform']}>
    <div className={styles['waveform__line']} />
    <div className={styles['waveform__line']} />
    <div className={styles['waveform__line']} />
    <div className={styles['waveform__line']} />
    <div className={styles['waveform__line']} />
  </div>
);
